<template>
    <div class="panel panel-default">
        <div class="panel-heading"><strong>{{ labels.nhi }}</strong></div>
        <div class="panel-body">
            <div class="row">
                <div class="col-md-4 form-group">
                    <label class="control-label">{{ labels.nhiSlug }}</label>
                    <input
                        class="form-control"
                        type="text"
                        :value="nhi.slug"
                        readonly
                        disabled
                    >
                </div>
                <div class="col-md-4 form-group">
                    <label class="control-label">{{ labels.nhiDisplayName }}</label>
                    <input
                        class="form-control"
                        type="text"
                        :value="nhi.display_name"
                        readonly
                        disabled
                    >
                </div>
                <div class="col-md-4 form-group" :class="{ 'has-error': fieldError('nhi.status') }">
                    <label class="control-label">{{ labels.status }}</label>
                    <select
                        v-model="nhi.status"
                        class="form-control"
                        name="nhi[status]"
                        :disabled="disabled"
                    >
                        <option v-for="(label, value) in statusOptions" :key="value" :value="value">{{ label }}</option>
                    </select>
                    <p v-if="fieldError('nhi.status')" class="help-block">{{ fieldError('nhi.status') }}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <tenant-user-select
                        v-model="nhi.owner_user_id"
                        :account-id="accountId"
                        :users-url="usersUrl"
                        :prefetched-users="prefetchedUsers"
                        name="nhi[owner_user_id]"
                        :label="labels.nhiOwner"
                        :empty-label="labels.nhiOwnerNone"
                        :allow-empty="true"
                        :disabled="disabled"
                        :error-message="fieldError('nhi.owner_user_id')"
                        :fallback-label="nhi.owner_label || ''"
                        input-id="nhi-owner-user-select"
                    ></tenant-user-select>
                </div>
                <div class="col-md-4 form-group" :class="{ 'has-error': fieldError('nhi.nhi_role_id') }">
                    <label class="control-label">{{ labels.nhiRole }}</label>
                    <select
                        v-model="nhi.nhi_role_id"
                        class="form-control"
                        name="nhi[nhi_role_id]"
                        :disabled="disabled"
                    >
                        <option :value="null">{{ labels.nhiRoleNone }}</option>
                        <option v-for="(label, value) in nhiRoleOptions" :key="value" :value="Number(value)">{{ label }}</option>
                    </select>
                    <p v-if="fieldError('nhi.nhi_role_id')" class="help-block">{{ fieldError('nhi.nhi_role_id') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TenantUserSelect from './TenantUserSelect.vue';

export default {
    components: {
        TenantUserSelect,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        accountId: {
            type: Number,
            required: true,
        },
        usersUrl: {
            type: String,
            default: '',
        },
        prefetchedUsers: {
            type: Array,
            default: () => [],
        },
        statusOptions: {
            type: Object,
            required: true,
        },
        nhiRoleOptions: {
            type: Object,
            default: () => ({}),
        },
        labels: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        nhi: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    methods: {
        fieldError(field) {
            const messages = this.validationErrors[field];

            return Array.isArray(messages) ? messages[0] : '';
        },
    },
};
</script>
